import {
  useReactTable,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
} from "@tanstack/react-table";

import './addStock.css';
import { ToastMessageContainer } from '../../../../../_ePulse/layout/components/ToastMessageContainer'
import { useEffect, useState } from 'react';
import { Checkbox } from "@mui/material";
import StringTypeInput from "./medicineTableInput/batchNumberInput";
import ProductNameEditor from "./medicineTableInput/productNameEditor";
import PackUnitInput from "./medicineTableInput/packUnitInput";
import NumberInput from "./medicineTableInput/numberInput";
import { update } from "lodash";
import ExpiryDateInput from "./medicineTableInput/expiryDateInput";
import { ErrorModal } from "./utils/errorModal";
import { BillDetailsFields } from "./utils/billDetailsFields";
import { DeleteCellModal } from "./utils/deleteCellModal";
import { ColumnVisibility, OptionalColumnField } from "./utils/optionalFields";
import useLazyQueryApi from "../../../../../hooks/useLazyQuery";
import { GET_MATCHED_MEDICINE_AUTOCOMPLETE } from "../../GraphQLQueries/querys";

type User = {

  BATCH_NUMBER: string,
  PRODUCT_NAME: string,
  PRODUCT_ID: string,
  PACK_UNIT: string,
  PACK_SIZE: number | null,
  RATE: number | null,
  QTY: number | null,
  VALUE: number | null,
  MRP: number | null,
  EXPIRY_DATE: string,
  MANUFACTURER: string,
  GENERIC: string,
  SGST: number | null,
  CGST: number | null,
  DISCOUNT: null,
  DISCOUNT_IN_PERCENTAGE: null,
  HSNCODE: string,
  FREE: number | null,
}




export const NewMedicineTable = (props: any) => {

  const createNewRow = (): User => ({
    PRODUCT_ID: '',// or use a counter if crypto not available
    BATCH_NUMBER: '',
    PRODUCT_NAME: '',
    PACK_UNIT: '',
    PACK_SIZE: null,
    QTY: null,
    RATE: null,
    VALUE: null,
    MRP: null,
    EXPIRY_DATE: '',
    MANUFACTURER: '',
    GENERIC: '',
    SGST: null,
    CGST: null,
    DISCOUNT: null,
    DISCOUNT_IN_PERCENTAGE: null,
    HSNCODE: '',
    FREE: null,
  });

  const [data, setData] = useState<User[]>(props.OCRData
    ? props.OCRData : [createNewRow()]);
  const [errorMsg, setErrorMsg] = useState([])
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [cashDiscount, setCashDiscount] = useState(0)
  const [netInvoice, setNetInvoice] = useState(0)
  const [isAddFields, setAddFields] = useState(false)
  const [selectField, setSelectField] = useState(OptionalColumnField)
  const [removeColumnField, setRemoveColumnField] = useState([{}])
  const [isShowDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedColumnField, setSelectedColumnField] = useState([{}])
  const [listing, setList] = useState<[]>([]);
  const [unSelectedColumnField, setUnSelectedColumnField] = useState<[]>([])


  const {
    fetchData,
    loading: loadingMedicine,
    error: MedicineError,
    data: medicineData,
  } = useLazyQueryApi(true, GET_MATCHED_MEDICINE_AUTOCOMPLETE)

  useEffect(() => {
    setList(medicineData?.getMatchedMedicineList)
  }, [medicineData])


  const [columnVisibility, setColumnVisibility] = useState<ColumnVisibility>({
    PRODUCT_ID: false,
    SGST: true,
    CGST: true,
    DISCOUNT: true,
    DISCOUNT_IN_PERCENTAGE: true,
    HSNCODE: true,
    GENERIC: true,
    FREE: true,
  })


  const columnHelper = createColumnHelper<User>();

  const columns = [
    columnHelper.accessor((row) => '', {
      id: 'select-col',

      header: ({ table }) => (
        <Checkbox style={{ 'padding': '0px', }}
          className='d-flex text-black'
          checked={table.getIsAllRowsSelected()}
          indeterminate={table.getIsSomeRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()} //or getToggleAllPageRowsSelectedHandler
        />
      ),
      cell: ({ row }) => (
        <div className='d-flex ms-8'>
          <Checkbox
            className='text-black fw-bold fs-7 '
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            onChange={row.getToggleSelectedHandler()}
          />
        </div>
      ),
    }),


    columnHelper.accessor((row) => row.BATCH_NUMBER, {
      id: "BATCH_NUMBER",
      header: () => <span className='d-flex text-black'>Batch Number</span>,
      cell: (props) => <StringTypeInput props={props} placeholder={"Batch Number"} />
    }),
    columnHelper.accessor((row) => row.PRODUCT_ID, {
      id: "PRODUCT_ID",
      header: () => <span className='d-flex text-black'>Product Id</span>,
      cell: (props) => <StringTypeInput props={props} placeholder={"Product Id"} />
    }),

    columnHelper.accessor((row) => row.PRODUCT_NAME, {
      id: "PRODUCT_NAME",
      header: () => <span className='d-flex  text-black'>Product Name</span>,
      cell: (props) => <StringTypeInput props={props} placeholder={"Product Name"} />,

    }),
    columnHelper.accessor((row) => row.PACK_UNIT, {
      id: "PACK_UNIT",
      header: () => <span className='d-flex text-black'>Pack Unit</span>,
      cell: (props) => <PackUnitInput props={props} />,
      enableHiding: false,
    }),

    columnHelper.accessor((row) => row.PACK_SIZE, {
      id: "PACK_SIZE",
      header: () => <span className='d-flex text-black'>Pack Size</span>,
      cell: (props) => <NumberInput props={props} placeholder={"Pack Size"} />
    }),
    columnHelper.accessor((row) => row.RATE, {
      id: "RATE",
      header: () => <span className='d-flex text-black'>Rate</span>,
      cell: (props) => <NumberInput props={props} placeholder={'Rate'} />
    }),
    columnHelper.accessor((row) => row.QTY, {
      id: "QTY",
      header: () => <span className='d-flex text-black'>Qty</span>,
      cell: (props) => <NumberInput props={props} placeholder={'Qty'} />
    }),
    columnHelper.accessor((row) => row.VALUE, {
      id: "VALUE",
      header: () => <span className='d-flex  text-black'>Value</span>,
      cell: (props) => <NumberInput props={props} placeholder={"Value"} />
    }),
    columnHelper.accessor((row) => row.MRP, {
      id: "MRP",
      header: () => <span className='d-flex text-black'>MRP</span>,
      cell: (props) => <NumberInput props={props} placeholder={"Mrp"} />
    }),

    columnHelper.accessor((row) => row.EXPIRY_DATE, {
      id: "EXPIRY_DATE",
      header: () => <span className='d-flex text-black'>EXPIRY DATE</span>,
      cell: (props) => <ExpiryDateInput props={props} placeholder={"Ex"} />
    }),

    columnHelper.accessor((row) => row.MANUFACTURER, {
      id: "MANUFACTURER",
      header: () => <span className='d-flex  text-black'>Manufacturer</span>,
      cell: (props) => <StringTypeInput props={props} placeholder={"Manufacturer"} />
    }),
    columnHelper.accessor((row) => row.GENERIC, {
      id: "GENERIC",
      header: () => <span className='d-flex text-black'>GENERIC</span>,
      cell: (props) => <StringTypeInput props={props} placeholder={"Generic"} />
    }),
    columnHelper.accessor((row) => row.HSNCODE, {
      id: "HSNCODE",
      header: () => <span className='d-flex text-black'>HSN CODE</span>,
      cell: (props) => <StringTypeInput props={props} placeholder={"HSN CODE"} />
    }),

    columnHelper.accessor((row) => row.SGST, {
      id: "SGST",
      header: () => <span className='d-flex text-black'>SGST</span>,
      cell: (props) => <NumberInput props={props} placeholder={"SGST"} />
    }),
    columnHelper.accessor((row) => row.CGST, {
      id: "CGST",
      header: () => <span className='d-flex text-black'>CGST</span>,
      cell: (props) => <NumberInput props={props} placeholder={"CGST"} />
    }),
    columnHelper.accessor((row) => row.DISCOUNT, {
      id: "DISCOUNT",
      header: () => <span className='d-flex  text-black'>DISCOUNT</span>,
      cell: (props) => <NumberInput props={props} placeholder={"Discount"} />
    }),
    columnHelper.accessor((row) => row.DISCOUNT_IN_PERCENTAGE, {
      id: "DISCOUNT_IN_PERCENTAGE",
      header: () => <span className='d-flex text-black'>DISCOUNT %</span>,
      cell: (props) => <NumberInput props={props} placeholder={"Disocunt %"} />
    }),
    columnHelper.accessor((row) => row.FREE, {
      id: "FREE",
      header: () => <span className='d-flex  text-black'>FREE</span>,
      cell: (props) => <NumberInput props={props} placeholder={"Free"} />
    }),

  ]

  const setState = () => {
    // setColumnVisibility()
  }

  const handleAddField = () => {
    setAddFields(!isAddFields)
  }

  const handleSelectFieldCheckbox = (position: number) => {
    const updatedCheckedState = selectField.map((item, index) =>
      index === position
        ? { name: item.name, id: item.id, selected: !item.selected }
        : { name: item.name, id: item.id, selected: item.selected }
    )
    setSelectField(updatedCheckedState)
  }

  const handleColumnField = () => {
    setAddFields(false);

    const fieldsToRemove = selectField.filter(item => !item.selected && columnVisibility[item.id]);
    const fieldsToAdd = selectField.filter(item => item.selected && !columnVisibility[item.id]);

    if (fieldsToRemove.length > 0) {
      setRemoveColumnField(fieldsToRemove);
      setSelectedColumnField(fieldsToAdd);
      setShowDeleteModal(true);
    } else {

      const updatedVisibility = { ...columnVisibility };
      fieldsToAdd.forEach((field) => {
        updatedVisibility[field.id] = true;
      });
      setColumnVisibility(updatedVisibility);
    }
  };

  const addRemoveColumnFieldInTable = () => {
    setShowDeleteModal(false);

    const updatedVisibility = { ...columnVisibility };

    removeColumnField.forEach((field: any) => {
      updatedVisibility[field.id] = false;
    });

    selectedColumnField.forEach((field: any) => {
      updatedVisibility[field.id] = true;
    });

    setColumnVisibility(updatedVisibility);

    const updatedFields = selectField.map((field) => {
      if (updatedVisibility[field.id] !== undefined) {
        return { ...field, selected: updatedVisibility[field.id] };
      }
      return field;
    });
    setSelectField(updatedFields);
  };

  const cancelRemoveColumnFieldInTable = () => {
    setShowDeleteModal(false);

    const updatedVisibility = { ...columnVisibility };
    selectedColumnField.forEach((field: any) => {
      if (field.id) {
        updatedVisibility[field.id] = true;
      }
    });

    setColumnVisibility(updatedVisibility);

    const updatedFields = selectField.map((field) => {
      const isStillSelected = removeColumnField.some((f: any) => f.id === field.id);
      return { ...field, selected: isStillSelected || field.selected };
    });

    setSelectField(updatedFields);
  };



  const table = useReactTable({
    data: data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    enableRowSelection: true,

    state: {
      columnVisibility,
    },
    onColumnVisibilityChange: setState,

    meta: {
      updateData: (rowIndex: number, columnId: string, value: any) => {

        setData(prev =>
          prev.map((row, i) =>
            i === rowIndex
              ? {
                ...row,
                [columnId]: value,
                ...(columnId === "QTY" || columnId === "RATE"
                  ? {
                    VALUE:
                      columnId === "QTY"
                        ? parseFloat((value * (row.RATE ?? 0)).toFixed(2))
                        : parseFloat(((row.QTY ?? 0) * value).toFixed(2)),
                  }
                  : {}),
              }
              : row
          )
        );
      },
    }
  });




  const handleAddRow = () => {
    const isValidated = validation(data)
    if (isValidated) {
      setData((prevItems) => [...prevItems, createNewRow()])
    }
  }



  const validation = (rows: any) => {
    let errorMessages: any = []

    console.log("rows--->>", rows)

    rows.forEach((row: any, index: any) => {
      if (
        !row.BATCH_NUMBER ||
        !row.PRODUCT_NAME ||
        !row.PACK_UNIT ||
        row.PACK_SIZE ||
        !row.EXPIRY_DATE ||
        !row.MANUFACTURER ||
        !row.MRP ||
        !row.RATE
      ) {
        if (!row.BATCH_NUMBER) errorMessages.push(`Row - ${index + 1} in Batch Number `)
        if (row.PACK_UNIT === undefined|| row.PACK_UNIT ===null || row.packSize === 'SELECT')
          errorMessages.push(`Row - ${index + 1} in Pack Unit `)
        if (!row.PRODUCT_NAME) errorMessages.push(`Row - ${index + 1} in Product Name `)
        if (!row.PACK_SIZE) errorMessages.push(`Row - ${index + 1} in Pack Size `)
        if (row.MRP === null || row.mrp < 0) errorMessages.push(`Row - ${index + 1} in MRP`)
        if (row.QTY === null || row.qty < 0) errorMessages.push(`Row - ${index + 1} in QTY`)
        if (row.RATE === null || row.rate < 0) {
          errorMessages.push(`Row - ${index + 1} in Rate`)
        }
        if (!row.EXPIRY_DATE) errorMessages.push(`Row - ${index + 1} in Expiry Date `)
        if (!row.MANUFACTURER) errorMessages.push(`Row - ${index + 1} in Manufacturer `)

        if (Number(row.DISCOUNT) > 0 && Number(row.DISCOUNT_IN_PERCENTAGE) > 0)
          errorMessages.push(
            `Row - ${index + 1} in Fill either Discount% or Discount Amount, not both`
          )
        if (Number(row.MRP) < Number(row.RATE))
          errorMessages.push(`Row - ${index + 1} in Rate can't be greater than MRP `)
      }

    })

    if (errorMessages.length > 0) {
      setErrorMsg(errorMessages)
      setShowErrorModal(true)
      return false
    }
    return true
  }


  const handleDeleteRow = () => {
    const selectedIndexes = table.getSelectedRowModel().rows.map(row => row.index);

    setData(preData => preData.filter((_row, index) => !selectedIndexes.includes(index)))
    table.resetRowSelection();
  }

  const calculation = (rowsData: any) => {
    // const rowsData = gridApi.current?.props.rowData;

    let details: BillDetailsFields = {
      totalAmount: 0,
      cashDiscount: 0,
      discountAmount: 0,
      cgstPayable: 0,
      sgstPayable: 0,
      netAmount: 0,
      totalUnits: 0,
    }

    let totalAmt = 0
    let cgstCalc = 0
    let sgstCalc = 0
    let disc: number = 0
    let discCalc = 0

    if (rowsData == null || rowsData.length < 1) {
      return details
    }

    rowsData?.map((row: any) => {
      totalAmt += row.VALUE === undefined || row.VALUE === null ? 0 : Number(row.VALUE)
      const currentdiscount = row.DISCOUNT
        ? Number(row.DISCOUNT)
        : (Number(row.QTY) * Number(row.RATE) * row.DISCOUNT_IN_PERCENTAGE) / 100
      disc = disc + (currentdiscount || 0)
      discCalc = row.VALUE - (currentdiscount || 0)
      cgstCalc = cgstCalc + (discCalc * row.cgst || 0) / 100
      sgstCalc = sgstCalc + (discCalc * row.sgst || 0) / 100
    })

    details.totalAmount = totalAmt
    details.cashDiscount = cashDiscount
    details.discountAmount = disc
    details.sgstPayable = sgstCalc
    details.cgstPayable = cgstCalc
    details.totalUnits = rowsData.length

    if (cashDiscount) {
      const finalAmt = totalAmt - cashDiscount - disc + cgstCalc + sgstCalc

      setNetInvoice(finalAmt)
      details.netAmount = finalAmt
    } else {
      const finalAmt = totalAmt - disc + cgstCalc + sgstCalc
      setNetInvoice(finalAmt)

      details.netAmount = finalAmt
    }

    return details
  }

  const purchaseOrderDetails = () => {
    let isValid = false


    isValid = validation(data)
    if (isValid) {
      const result = calculation(data)
      props.handleTableData(data)
      props.onSubmitDetails({ result })
    }
  }

  return (
    <div>
      {showErrorModal && (
        <ErrorModal
          modalState={showErrorModal}
          closeModal={() => {
            setShowErrorModal(false)
          }}
          errorMessage={errorMsg}
        />
      )}
      <ToastMessageContainer />
      {isShowDeleteModal && (
        <DeleteCellModal
          modalState={isShowDeleteModal}
          onCancel={cancelRemoveColumnFieldInTable}
          onDelete={addRemoveColumnFieldInTable}
        />
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px' }}>
        <div>
          {' '}
          <h1>Medicine Table </h1>
        </div>
        <div style={{ display: 'flex' }}>
          <div className='filter-row ePulse-divider justify-content-end'>
            {' '}
            <button className='ePulse-button' onClick={() => handleAddRow()}>
              Add Row
            </button>
          </div>
          <div className='filter-row ePulse-divider justify-content-end'>
            <button
              className='ePulse-button'
              onClick={handleDeleteRow}
            //   style={isDeleteRow ? {backgroundColor: 'red'} : {}}
            >
              Delete Row
            </button>
          </div>
          <div className='filter-row ePulse-divider justify-content-end'>
            {' '}
            <button
              className='ePulse-button'
              onClick={isAddFields ? handleColumnField : handleAddField}
            >
              {isAddFields ? ' Done ' : 'Manage Fields '}
            </button>
          </div>
        </div>
      </div>
      {isAddFields &&
        OptionalColumnField.map(({ name }, index) => {
          return (
            <div className='optional-field-list'>
              <input
                type='checkbox'
                name={name}
                value={name}
                id={`custom-${index}`}
                checked={selectField[index].selected}
                onChange={() => handleSelectFieldCheckbox(index)}
              />
              <label htmlFor={`custom-${index}`}> {name}</label>
            </div>
          )
        })}
      <div className="custom-scrollbar">
        <div style={{ minWidth: '600px', minHeight: '200px' }}>
          <div className='admin-table'>
            <table className='table'>
              <thead >
                {table.getHeaderGroups().map((headerGroup) => {
                  return (
                    <tr className='text-center text-dark fw-bolder fs-6 MyReactTableClass' key={headerGroup.id}>
                      {headerGroup.headers.map((header) => {
                        return (
                          <th id={header.id}>
                            {" "}
                            {header.isPlaceholder
                              ? null
                              : flexRender(
                                header.column.columnDef.header,
                                header.getContext(),
                              )}
                          </th>
                        );
                      })}
                    </tr>
                  );
                })}
              </thead>
              <tbody className='text-black fw-normal text-center'>
                {table.getRowModel().rows.map((row, index) => {
                  return (
                    <tr key={row.id}
                      className="bg-white"
                    //    className= {`
                    //         ${row.getIsSelected()} ? 'selected' : null ,
                    //         ${index === 0} ? 'bg-white' : 'bg-white`}
                    >
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <td key={cell.id}>
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-end'>
        <button className='ePulse-button' onClick={purchaseOrderDetails}>
          {' '}
          Continue{' '}
        </button>
      </div>
    </div>
  );
}